import React from 'react'

const About = () => {
  return (
    <div class='about-div1'>
        <div class='about-div'>
            {/* <h1 class='about-h'>About Us</h1> */}
        </div>
        <h1 class='about-h2'>Delivering reliable fire protection solutions to safeguard lives, property, and businesses.</h1>
        <div class='container'>
            <div class='row mt-5'>
                <div class='col-12 col-sm-12 col-md-12 col-lg-6'>
                   <img src='./Images/img1.jpg' alt='' class='about-img' />
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-6'>
                    <h2 class='about-h1 '>About Us</h2>
                    <p class='about-p mt-3'>RJ Engineering Fire Safety Protection Service is a trusted provider of fire protection systems and safety solutions for residential, commercial, and industrial buildings. We specialize in the supply, installation, and maintenance of fire safety equipment including fire extinguishers, fire alarm systems, fire hydrant systems, and fire sprinkler systems.</p>
                    <p class='about-p mt-3'>Our mission is to protect lives and property by delivering reliable, high-quality fire safety solutions that meet industry standards and safety regulations. With a skilled team and a commitment to safety, RJ Engineering ensures that every project is completed with professionalism, efficiency, and attention to detail.</p>
                    <p class='about-p mt-3'>At RJ Engineering, safety is our priority and customer satisfaction is our goal.</p>
                </div>
            </div>
            <div class='row mt-5'>
                <div class='col-12 col-sm-12 col-md-12 col-lg-6'>
                    <img src='./Images/img4.jpg' alt='' class='about-img1' />
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-6 mt-2'>
                    <h3 class='about-m'>🔥 Our Mission</h3>
                    <p class='about-p1'>To protect lives and property by providing high-quality fire safety systems and reliable protection services.</p>
                    <h3 class='about-v'>👁 Our Vision</h3>
                    <p class='about-p1'>Our vision is to become a trusted leader in fire safety protection services by providing innovative, reliable, and high-quality fire protection solutions. We aim to create safer environments for homes, businesses, and industries by promoting effective fire prevention systems, advanced safety technologies, and professional service. Through our commitment to safety and excellence, we strive to protect lives, property, and communities from fire risks.</p>
                </div>
            </div>
        </div>
        <div class='d-flex justify-content-center mt-4'>
            <h1 class='about-h3'>Our Services</h1>
        </div>
        <div class='container'>
            <div class='row mt-4'>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <img src='./Images/service.jpg' alt='' class='about-ser mt-5' />
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Fire Alarm</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <img src='./Images/img5.jpg' alt='' class='about-ser mt-5' />
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Fire hydrant</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <img src='./Images/img3.jpg' alt='' class='about-ser mt-5' />
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Sprinkler</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <img src='./Images/extin.jpg' alt='' class='about-ser mt-5' />
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Fire Extinguisher</h5>
                </div>
            </div>
            <div class='row mt-4'>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <img src='./Images/service.jpg' alt='' class='about-ser mt-5' />
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Fire Alarm</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <img src='./Images/service.jpg' alt='' class='about-ser mt-5' />
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Fire Alarm</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <img src='./Images/service.jpg' alt='' class='about-ser mt-5' />
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Fire Alarm</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <img src='./Images/service.jpg' alt='' class='about-ser mt-5' />
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Fire Alarm</h5>
                </div>
            </div>
        </div>
        <div class='home-hr'>
            <h1 class='home-h3 mt-5'>Why Choose Rj Engineering?</h1>
        </div>
        <div>
            <p class='home-para1 mt-3'>At RJ Engineering Fire Protection & Safety, we are committed to delivering reliable and advanced fire safety solutions to protect lives, property, and businesses. Our focus on quality, safety standards, and customer satisfaction makes us a trusted partner for fire protection services.</p>
        </div>
        <div class='container'>
            <div class='row'>
               <div class='col-12 col-sm-12 col-md-6 col-lg-6'>
                  <h3 class='home-head'>1. Experienced Professionals</h3>
                  <p class='home-par'>Our team consists of trained engineers and fire safety experts with strong experience in installing and maintaining fire protection systems.</p>
                  <h3 class='home-head'>2. High-Quality Fire Safety Equipment</h3>
                  <p class='home-par'>We supply and install certified fire safety equipment including fire extinguishers, fire alarms, hydrant systems, and sprinkler systems.</p>
                  <h3 class='home-head'>3. Compliance with Safety Standards</h3>
                  <p class='home-par'>All our installations follow industry safety standards and fire department regulations to ensure maximum protection.</p>
                  <h3 class='home-head'>4. Customized Safety Solutions</h3>
                  <p class='home-par'>Every building has different safety needs, so we design fire protection systems tailored to your property.</p>
               </div>
               <div class='col-12 col-sm-12 col-md-6 col-lg-6'>
                  <h3 class='home-head'>5. Complete Fire Protection Solutions</h3>
                  <p class='home-par'>From fire safety audits to system installation and maintenance, we provide end-to-end fire protection services.</p>
                  <h3 class='home-head'>6. Quick Response & Reliable Support</h3>
                  <p class='home-par'>Our team is ready to respond quickly to service requests and emergency situations to keep your premises safe.</p>
                  <h3 class='home-head'>7. Affordable & Customized Solutions</h3>
                  <p class='home-par'>We offer cost-effective fire safety systems tailored to the specific needs of residential, commercial, and industrial properties.</p>
                  <h3 class='home-head'>8. Customer Satisfaction</h3>
                  <p class='home-par'>We prioritize long-term relationships by providing dependable service and ongoing support to all our clients.</p>
               </div>
            </div>
        </div>
        <div class='container'>
            <div class='row mt-4'>
            <h2 class='about-h4'>🔥 Need Professional Fire Safety Installation?</h2>
            <p class='about-para1'>📞 Contact RJ Engineering today for reliable fire protection solutions.</p>
            </div>
        </div>
    </div>
  )
}

export default About